import { useState, useEffect, useCallback } from 'react';
import { sponsors } from '../../databases/sponsors';

const SponsorBarMobile = ({ calculatorType }) => 
{
  const [visibleSponsors, setVisibleSponsors] = useState(6);
  const [sponsorsToShow, setSponsorsToShow] = useState([]);
  const [rotationKey, setRotationKey] = useState(0);

  // Función para mezclar array aleatoriamente
  const shuffleArray = useCallback((array) => 
  {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  }, []);

  // Generar SVG completo
  const renderLogo = useCallback((svgContent) =>
  {
    return `
      <svg  className="h-9 hover:text-gray-900 dark:hover:text-white" version="1.0" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 1420 320">
        <g transform="translate(0,320) scale(0.1,-0.1)" fill="currentColor" stroke="none">
            ${svgContent}
        </g>
      </svg>
    `;
  }, []);

  // Actualizar sponsors visibles según pantalla
  const updateVisibleSponsors = useCallback(() =>
  {
    const width = window.innerWidth;

    setVisibleSponsors(
      (width - 400) < 640  ? 4 :
      (width - 400) < 768 ? 5 : 6
    );
  }, []);

  // Actualizar lista de sponsors a mostrar
  const updateSponsorsToShow = useCallback(() => 
  {
    // 1. Obtener sponsors principales para la categoría actual (mezclados)
    const mainSponsors = shuffleArray(
      sponsors.filter(s => 
        s.categoria === 'principales' && 
        s.subcategoria.includes(calculatorType)
    ));

    // 2. Obtener sponsors no principales (mezclados y filtrados)
    const regularSponsors = shuffleArray(
      sponsors.filter(s => 
        s.categoria !== 'principales' || 
        !s.subcategoria.includes(calculatorType)
    )
    .sort((a, b) => b.relevancia - a.relevancia)
    .slice(0, 8)); // Limitar pool de sponsors regulares

    // 3. Calcular cuántos sponsors regulares podemos mostrar
    const availableMainSlots = Math.min(mainSponsors.length, visibleSponsors);
    const regularSlotsToShow = Math.max(visibleSponsors - availableMainSlots, 0);

    // 4. Seleccionar sponsors regulares a mostrar (aleatorio)
    const selectedRegulars = shuffleArray(regularSponsors).slice(0, regularSlotsToShow);

    // 5. Combinar y establecer la lista final
    setSponsorsToShow([
      ...shuffleArray(mainSponsors).slice(0, availableMainSlots),
      ...selectedRegulars
    ]);
  }, [calculatorType, visibleSponsors, shuffleArray]);

  // Configurar intervalos y event listeners
  useEffect(() => 
  {
    updateVisibleSponsors();
    updateSponsorsToShow();
    
    const handleResize = () =>
    {
      updateVisibleSponsors();
    };

    // Rotar sponsors cada 30 segundos
    const rotationInterval = setInterval(() => 
    {
      setRotationKey(prev => prev + 1);
    }, 30000);

    window.addEventListener('resize', handleResize);

    return () => 
    {
      clearInterval(rotationInterval);
      window.removeEventListener('resize', handleResize);
    };
  }, [updateVisibleSponsors, updateSponsorsToShow]);

  // Actualizar sponsors cuando cambia la key de rotación
  useEffect(() =>
  {
    updateSponsorsToShow();
  }, [rotationKey, updateSponsorsToShow]);

  return (
    <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6">
      {sponsorsToShow.map((sponsor) => (
        <a
          key={`${sponsor.id}-${rotationKey}`}
          href={sponsor.enlace}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center bg-white text-gray-500 px-2 rounded-lg shadow-xs"
          style={{
            width: '80px',
            height: '40px',
            minWidth: '80px'
          }}
          title={sponsor.descripcion}
        >
          <div 
            className="w-full h-full flex items-center justify-center"
            dangerouslySetInnerHTML={{ __html: renderLogo(sponsor.svgContent) }}
          />
        </a>
      ))}
    </div>
  );
};

export default SponsorBarMobile;